var map = {
	"./2factor-authentication.EN.html": [
		"./assets/static_pages/2factor-authentication.EN.html",
		2
	],
	"./agreement-conditions.EN.html": [
		"./assets/static_pages/agreement-conditions.EN.html",
		3
	],
	"./api-access.EN.html": [
		"./assets/static_pages/api-access.EN.html",
		4
	],
	"./api-documentation.EN.html": [
		"./assets/static_pages/api-documentation.EN.html",
		5
	],
	"./buy-bitcoins.EN.html": [
		"./assets/static_pages/buy-bitcoins.EN.html",
		6
	],
	"./buy-dash.EN.html": [
		"./assets/static_pages/buy-dash.EN.html",
		7
	],
	"./buy-ethereum.EN.html": [
		"./assets/static_pages/buy-ethereum.EN.html",
		8
	],
	"./buy-etherium.EN.html": [
		"./assets/static_pages/buy-etherium.EN.html",
		9
	],
	"./cookies-policy.EN.html": [
		"./assets/static_pages/cookies-policy.EN.html",
		10
	],
	"./deposit-and-withdrawal.EN.html": [
		"./assets/static_pages/deposit-and-withdrawal.EN.html",
		11
	],
	"./description-of-services.EN.html": [
		"./assets/static_pages/description-of-services.EN.html",
		12
	],
	"./eligibility.EN.html": [
		"./assets/static_pages/eligibility.EN.html",
		13
	],
	"./fees-and-limits.EN.html": [
		"./assets/static_pages/fees-and-limits.EN.html",
		14
	],
	"./introduction.EN.html": [
		"./assets/static_pages/introduction.EN.html",
		15
	],
	"./privacy-policy.EN.html": [
		"./assets/static_pages/privacy-policy.EN.html",
		16
	],
	"./privacy-policy/amendments.EN.html": [
		"./assets/static_pages/privacy-policy/amendments.EN.html",
		17
	],
	"./privacy-policy/collection-info.EN.html": [
		"./assets/static_pages/privacy-policy/collection-info.EN.html",
		18
	],
	"./privacy-policy/cookies.EN.html": [
		"./assets/static_pages/privacy-policy/cookies.EN.html",
		19
	],
	"./privacy-policy/disclosure-info.EN.html": [
		"./assets/static_pages/privacy-policy/disclosure-info.EN.html",
		20
	],
	"./privacy-policy/general-provisions.EN.html": [
		"./assets/static_pages/privacy-policy/general-provisions.EN.html",
		21
	],
	"./privacy-policy/terms-and-definitions.EN.html": [
		"./assets/static_pages/privacy-policy/terms-and-definitions.EN.html",
		22
	],
	"./privacy-policy/use-info.EN.html": [
		"./assets/static_pages/privacy-policy/use-info.EN.html",
		23
	],
	"./prohibition-of-use.EN.html": [
		"./assets/static_pages/prohibition-of-use.EN.html",
		24
	],
	"./terms-and-conditions.EN.html": [
		"./assets/static_pages/terms-and-conditions.EN.html",
		25
	],
	"./trading.EN.html": [
		"./assets/static_pages/trading.EN.html",
		26
	],
	"./verification.EN.html": [
		"./assets/static_pages/verification.EN.html",
		27
	],
	"./whitepaper.EN.html": [
		"./assets/static_pages/whitepaper.EN.html",
		28
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./assets/static_pages lazy recursive ^\\.\\/.*\\.EN\\.html$";
module.exports = webpackAsyncContext;